export class Config {
  baseUrl = 'https://api.darujkrv.me/';
  // baseUrl = 'http://localhost:3005/';
  // baseUrl = 'http://192.168.100.11:8080/api/';
  // imgUrl = 'https://dhm.org.me/upload/img/';
}
